import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CustomerNoteCellContent: React.FC<CustomerNoteCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.CustomerNote];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item);
	}, [item]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CustomerNoteCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default CustomerNoteCellContent;
